import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";  // add this
import { Link, useNavigate } from "react-router-dom";

export default function CreateMutualFund() {
    const navigate = useNavigate();
    const [fund, setFund] = useState({
        fund_name: "",
        category: "",
        returns: "",
        risk: "",
        nav: "",
        fund_manager: "",
        aum: "",
        rating: "",
        risk_level: "",
        ideal_for: "",
        lock_in_period: "",
        tax_benefit: "",
    });
    const [file, setFile] = useState(null);

    const handleChange = (e) => {
        setFund({ ...fund, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(
                `${process.env.REACT_APP_BACKEND_BASE_URL}/mutualfund/store`,
                fund
            );
            Swal.fire("Success", "Mutual Fund created successfully", "success");
            navigate("/mutualfund");
        } catch (error) {
            Swal.fire("Error", "Failed to create mutual fund", "error");
        }
    };

    const handleFileUpload = async (e) => {
        e.preventDefault();
        if (!file) {
            Swal.fire("Warning", "Please select a file", "warning");
            return;
        }
        const formData = new FormData();
        formData.append("file", file);

        try {
            await axios.post(
                `${process.env.REACT_APP_BACKEND_BASE_URL}/mutualfund/upload-excel`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            Swal.fire("Success", "Excel uploaded successfully", "success");
            navigate("/mutualfund");
        } catch (error) {
            Swal.fire("Error", "Failed to upload Excel", "error");
        }
    };



    // const [file, setFile] = useState(null);
    const [fileData, setFileData] = useState([]); // for preview

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);

        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: "array" });

                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                // FIX: keep empty columns
                const parsedData = XLSX.utils.sheet_to_json(sheet, {
                    defval: "", // 🔥 this keeps blank columns like "25 YEAR"
                });

                setFileData(parsedData);
            };
            reader.readAsArrayBuffer(selectedFile);
        }
    };


    return (
        <div className="main-content">
            <div className="page-wrapper page-settings">
                <div className="content">
                    {/* Breadcrumb and Header Section with Card Shadow */}
                    <div
                        className="mb-4"
                        style={{
                            background: "#ffffff",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            padding: "20px",
                        }}
                    >
                             <div className="content-page-header content-page-headersplit">
                            <h5>Add Mutual Fund</h5>
                        </div>
                        <nav
                            aria-label="breadcrumb"
                            style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
                        >
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Dashboard</Link> /
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="/mutualfund">Mutual Funds</Link> /
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Add Mutual Fund
                                </li>
                            </ol>
                        </nav>
                   
                    </div>

                    {/* Upload Form Section with Card Shadow */}
                    <div
                        className="mb-4"
                        style={{
                            background: "#ffffff",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            padding: "20px",
                        }}
                    >
                        <h4
                            style={{
                                marginBottom: "20px",
                                fontSize: "18px",
                                fontWeight: 600,
                                color: "#006e82",
                            }}
                        >
                            Upload via Excel
                        </h4>
                        <form onSubmit={handleFileUpload}>
                            <div className="row g-3 mb-3">
                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                                            Select Excel File (.xlsx, .xls)
                                        </label>
                                        <input
                                            type="file"
                                            required
                                            className="form-control"
                                            onChange={handleFileChange}
                                            accept=".xlsx, .xls"
                                        />
                                        {file && (
                                            <small className="text-muted mt-2 d-block">
                                                Selected: {file.name}
                                            </small>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex gap-2">
                                <Link to="/mutualfund" className="btn btn-cancel">
                                    <i className="fas fa-arrow-left me-2"></i>
                                    Back
                                </Link>
                                <button type="submit" className="btn btn-primary">
                                    <i className="fas fa-upload me-2"></i>
                                    Upload & Submit
                                </button>
                            </div>
                        </form>
                    </div>

                    {/* Preview Table Section with Card Shadow */}
                    {fileData.length > 0 && (() => {
                        const allColumns = Array.from(
                            new Set(
                                fileData.flatMap((row) => Object.keys(row))
                            )
                        );

                        return (
                            <div
                                className="mb-4"
                                style={{
                                    background: "#ffffff",
                                    borderRadius: "8px",
                                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                    padding: "20px",
                                }}
                            >
                                <h4
                                    style={{
                                        marginBottom: "20px",
                                        fontSize: "18px",
                                        fontWeight: 600,
                                        color: "#006e82",
                                    }}
                                >
                                    Preview Data ({fileData.length} row{fileData.length !== 1 ? "s" : ""})
                                </h4>
                                <div className="table-responsive">
                                    <table className="table datatable">
                                        <thead>
                                            <tr>
                                                {allColumns.map((col) => (
                                                    <th key={col}>{col}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fileData.map((row, i) => (
                                                <tr key={i}>
                                                    {allColumns.map((col) => (
                                                        <td key={col}>
                                                            {row[col] !== undefined && row[col] !== null && row[col] !== ""
                                                                ? row[col]
                                                                : "-"}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        );
                    })()}
                </div>
            </div>
        </div>
    );
}
